var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0_11146_11780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_11146_11780",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11146_11780",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_11146_11780",
    width: 48,
    height: 48,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACHUlEQVRoBe1Yu07DMBS9Eo8RiV9ACAlmGiYYGn6BL0BiYOAbOmGHDRS76i90Riz9DhASK48BqUu78JCCTJSHE5NeN04bI0eKGqf3de71PbYD4K7/mgFOI8jf1uHMBy+erbscgGWXzFXAVaBmBqyaQn3CJM4vBq8ahzSsmSKD6sPhCjBypwFiBL3eqsEIDJi66W1ASO9ngmDkETjZNOCxAROcbAEj7xUgxhBe7jTg2aDJkB5BSD8UIL6Ak2ODnho0xYLTEgAWnDfosQHTeWZqBePwYACDwRoaasZMeowT612j/aAFYy4faTGIYBsdxhFMxunt7/RDB4YVzBajJ2DBLlYNLcfINnDykPYOWhErmAEQJ62xUUbhV4cl+sXGhZaTAUTAyDf0gwuVfnSytz7194OJ771Oup2Xqe9R8U4lC5ycASOfaeYTP0rhqpeJovZvublFwFPfiwo3ldyLZuUBLQWO9S8ZEwOsolpOam6R+ULw0cT33lKf+WZV25M/CKhkUmPJg0oI/04GEE8bqQITv/OcuIJ2AUBOoe4BSQGIB+NTSLKuGBSrMbOJPSoaeHFNrIhZeiUDsJpGrV7IpGaVKqQatGorIXaXOsfAeTdzwofwtfSrddtpnYxYfaCx+khp9aHe6s8qGePM3oTFC6LeMVOn/+aSzTOOvGL/DagVB/0qtEUgVbKt/M8BWHZZXAVcBWpmwE2hmgl06gvKwA+9A5JtxV1fIQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparency);
export default __webpack_public_path__ + "static/media/transparency.d623ce5f5236541c32c9c84a003e686a.svg";
export { ForwardRef as ReactComponent };